import { useState, useEffect } from "react";
import {UploadIcon} from "../../icons/uploadIcon"
import {BinIcon} from "../../icons/binIcon"
import { FileUploadIcon } from "../../icons/fileUploadIcon";
import Dropzone from "react-dropzone";
import clsx from "clsx";

export const UploadFile = ({ prevFile, allowedTypes, onFileChange, itemIndex, canDelete = true, maxFiles, className, disabled=false }) => {
    const acceptedTypes = [
        { type: 'application/pdf', condition: allowedTypes.includes('pdf') },
        { type: 'image/tiff', condition: allowedTypes.includes('tiff') },
        { type: 'image/jpeg', condition: allowedTypes.includes('jfif') },
        { type: 'image/gif', condition: allowedTypes.includes('gif') },
        { type: 'image/bmp', condition: allowedTypes.includes('bmp') },
        { type: 'image/png', condition: allowedTypes.includes('png') },
        { type: 'image/jpeg', condition: allowedTypes.includes('jpeg') },
        { type: 'image/jpg', condition: allowedTypes.includes('jpg') },
        { type: 'image/webp', condition: allowedTypes.includes('webp') },
        { type: 'image/tiff', condition: allowedTypes.includes('tif') },
        { type: 'image/pjpeg', condition: allowedTypes.includes('pjpeg') },
        { type: 'image/avif', condition: allowedTypes.includes('avif') },
      ];
    const [file, setFile] = useState();

    
    useEffect(()=>{
        if (prevFile) {
            setFile(prevFile)
        }   
    }, [prevFile])
      
    const acceptObject = acceptedTypes
    .filter(type => type.condition)
    .reduce((acc, type) => {
        acc[type.type] = [];
        return acc;
    }, {});  

    return (
        <div className={clsx("flex items-center justify-center w-full max-w-[450px]",className)}>
            <Dropzone
                disabled={disabled}
                maxFiles={maxFiles}
                accept={acceptObject}
                onDrop={acceptedFiles => {
                onFileChange('upload', ...acceptedFiles);
                }}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        //VERY CAREFULL HERE IN CASE IT DOESNT WORK REMEMBER YOU'VE REMOVED THE LABEL TAG
                    <div {...getRootProps()} class={clsx("flex flex-col items-center justify-center gap-2 rounded-[12px] flex w-full flex-col items-center justify-center h-[172px] border border-[#A5A5A5] border-dashed cursor-pointer bg-white hover:bg-gray-100",disabled && 'opacity-70 hover:cursor-default')}>     
                        {!file ? 
                            <>
                                <UploadIcon />
                                <p class="text-sm text-[#A5A5A5] text-center">{isDragActive ? 'Drop the files here ...' : allowedTypes.join(', ')}</p> 
                            </>
                                :
                            <div className="space-between flex flex-col p-4 w-full h-[172px] rounded-[12px] bg-white">
                                <div className="w-full flex justify-between">
                                    <FileUploadIcon/>
                                        {canDelete && <div className="hover:cursor-pointer px-1.5 flex items-center rounded-full border border-[#A5A5A5]" onClick={() => { setFile(); onFileChange('remove') }}>
                                            <BinIcon />
                                        </div>
                                        }
                                </div>
                                <div>
                                    <h5 className="line-clamp-3">{file.name ?? file.type}</h5>
                                    <p className="text-[#A5A5A5] text-sm">{file.size && (file.size/1000000).toFixed(2) + 'MB'}</p>
                                </div>
                                <div className="w-full justify-end items-end h-full flex">
                                    <p className="text-sm text-[#D4002A] hover:underline">Αντικατάσταση Αρχείου</p>
                                </div>
                            </div>  
                        }
                        <input  {...getInputProps()} id={`dropzone-file-${itemIndex}`} />
                    </div>  
                )}
              </Dropzone>
    </div> 
    )
}